import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonChatStack } from './ChatStack.definition';
import { chameleonChatBubble } from './ChatBubble/ChatBubble.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonChatStack({ prefix }), chameleonChatBubble({ prefix }));
}
